import React from 'react';
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';

type TopCustomerOrProduct = {
  name: string;
  amount: number;
};

type CustomersCardProps = {
  topCustomers: {
    [key: string]: TopCustomerOrProduct;
  };
  year?: string;
};

const CustomersCard: React.FC<CustomersCardProps> = ({ topCustomers, year }) => {
  const customersList: TopCustomerOrProduct[] = Object.values(topCustomers || {});

  return (
    <Card style={{ height: '594px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
      <CardContent style={{ overflowY: 'auto', padding: '20px' }}>
        <Typography
          variant="h6"
          align="center"
          style={{ marginBottom: '16px', borderBottom: '1px solid #e0e0e0', paddingBottom: '16px' }}
        >
          Customer Delivered Metrics ({year})
        </Typography>
        <TableContainer component={Paper} style={{ boxShadow: 'none', overflow: 'initial' }}>
          <Table aria-label="simple table" style={{ minWidth: '265px' }}>
            <TableHead>
              <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                <TableCell>
                  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                    Customer
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" style={{ fontWeight: 'bold' }}>
                    Units Delivered
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customersList.map((customer, index) => {
                if (customer.name && customer.amount) {
                  return (
                    <TableRow key={customer.name} hover>
                      <TableCell component="th" scope="row">
                        {index + 1}. {customer.name}
                      </TableCell>
                      <TableCell align="right">{customer.amount.toFixed(2)} units</TableCell>
                    </TableRow>
                  );
                }
                return null;
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default CustomersCard;
